<template>
	<section v-closable="close" :class="['sk-navigation-select', {'sk-navigation-select--open': isOpen}]">
		<navigation-header :title="title" :subtitle="subtitle">
			<button @click="onToggle_ClickHandler" class="sk-navigation-select__toggle"><span class="sk-navigation-select__toggle-icon sk-icon sk-icon-down-arrow"></span></button>
		</navigation-header>
		<main class="sk-navigation-select__main"><slot></slot></main>
	</section>
</template>

<script>
import Closable from '@/directives/Closable'
import NavigationHeader from './NavigationHeader'
export default {
	name: 'navigation-select',
	components: {
		NavigationHeader
	},
	directives: {
		Closable
	},
	props: {
		title: {
			type: String,
			default: 'Navigation Select Title'
		},
		subtitle: {
			type: String,
			default: 'Navigation Select Subtitle'
		}
	},
	data() {
		return {
			isOpen: false
		}
	},
	methods: {
		onToggle_ClickHandler() {
			this.isOpen = !this.isOpen
		},
		close() {
			this.isOpen = false
		}
	}
}
</script>

<style scoped>
.sk-navigation-select {
	position: relative;
	height: var(--topbar-height);
	width: 100%;
}
/* @media screen and (max-width: 480px) {
	.sk-navigation-select {
		width: 100vw;
	}
} */
.sk-navigation-select__main {
	background-color: var(--main-color-soft);
	position: absolute;
	top: var(--topbar-height);
	width: 100%;
	height: calc(100vh - var(--topbar-height));
	padding: 50px 0;
	clip-path: inset(0 0 100% 0);
	transition: clip-path 0.3s;
	z-index: 999;
	overflow-y: auto;
	box-shadow: rgba(0,0,0,0.1) 1px 0 5px;
}
.sk-navigation-select--open .sk-navigation-select__main {
	clip-path: inset(0 -10px 0 0);
}
.sk-navigation-select__toggle {
	outline: none;
	cursor: pointer;
	width: var(--topbar-height);
	height: var(--topbar-height);
	border: 0;
	padding: 0;
	margin: 0;
	background-color: rgba(255, 255, 255, 0.2);
	display: flex;
	align-items: center;
	justify-content: center;
}
.sk-navigation-select__toggle-icon {
	width: 48px;
	height: 48px;
	background-size: 24px;
	background-position: center;
	transform: rotate(0deg) scale(1, 1);
	transition: transform 0.3s;
}
.sk-navigation-select--open .sk-navigation-select__toggle-icon {
	transform: rotate(180deg) scale(1, 1);
}
.sk-navigation-select__toggle:active .sk-navigation-select__toggle-icon,
.sk-navigation-select__toggle:hover .sk-navigation-select__toggle-icon {
	transform: rotate(0deg) scale(1.2, 1.2);
}
.sk-navigation-select--open .sk-navigation-select__toggle:active .sk-navigation-select__toggle-icon,
.sk-navigation-select--open .sk-navigation-select__toggle:hover .sk-navigation-select__toggle-icon {
	transform: rotate(180deg) scale(1.2, 1.2);
}
</style>


// WEBPACK FOOTER //
// src/components/navigation/NavigationSelect.vue